/* ------------------------------------------------------------
   INCIPIT — Selling Points  (Section 2/2)
   Fade-in séquentiel des points à l'entrée dans le viewport.
   - Progressif : sans JS, tout le contenu reste visible.
   - Respecte prefers-reduced-motion.
   - Compatible éditeur de thème (shopify:section:load).
   ------------------------------------------------------------ */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (root.dataset.iptInit === 'true') return;
    root.dataset.iptInit = 'true';

    var animEnabled = root.dataset.anim === 'true';

    if (!animEnabled || REDUCED || !('IntersectionObserver' in window)) {
      root.querySelectorAll('[data-ipt-reveal]').forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    // Arme les états "cachés" (uniquement maintenant que le JS est là).
    root.classList.add('incipit-anim');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    root.querySelectorAll('[data-ipt-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    // Filet de sécurité : révèle le contenu visible après 4s
    // si l'observer ne s'est pas déclenché.
    setTimeout(function () {
      root.querySelectorAll('[data-ipt-reveal]:not(.is-inview)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('is-inview');
        }
      });
    }, 4000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-incipit-points]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();